import React from "react";
import { useLocation } from "react-router-dom";

const WHATSAPP_NUMBER = "972522705344";

export const WhatsAppFeedbackButton = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const openWhatsApp = () => {
    const text = encodeURIComponent(
      `Hi! Feedback on ClassMate:\nPage: ${window.location.href}\n\n`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`, "_blank", "noopener");
  };

  return (
    <button
      onClick={openWhatsApp}
      data-testid="whatsapp-feedback-btn"
      aria-label="Send feedback on WhatsApp"
      className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-30 flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white shadow-lg pl-3 pr-4 py-3 transition-transform hover:scale-105"
    >
      <svg viewBox="0 0 32 32" className="h-6 w-6 fill-current" aria-hidden="true">
        <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.59-1.67a12.74 12.74 0 0 0 6.21 1.6h.01c7.06 0 12.79-5.74 12.79-12.8s-5.74-12.73-12.79-12.73zm0 23.36h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.91.99 1.04-3.81-.25-.39a10.55 10.55 0 0 1-1.63-5.64c0-5.86 4.77-10.63 10.64-10.63a10.57 10.57 0 0 1 10.62 10.66c0 5.86-4.85 10.53-10.71 10.53zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.14 3.09 1.3 3.3c.16.21 2.25 3.44 5.45 4.82.76.33 1.36.53 1.82.67.77.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z" />
      </svg>
      <span className="text-sm font-semibold hidden sm:inline">Feedback</span>
    </button>
  );
};
